import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { Locale } from '@api-types/enums/locale.enum';
import { LocaleService } from '@core/services/locale.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pm-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss'],
  imports: [
    MatRadioGroup,
    ReactiveFormsModule,
    MatRadioButton,
    TranslateModule,
  ],
})
export class ProfilePageComponent implements OnInit {
  private readonly localeService = inject(LocaleService);
  private readonly translateService = inject(TranslateService);
  languageFormControl: UntypedFormControl;
  options: { value: Locale; label: string }[] = [
    { label: 'PROFILE.LANGUAGE.DE-DE', value: Locale.GERMAN },
    { label: 'PROFILE.LANGUAGE.EN-GB', value: Locale.UK },
    { label: 'PROFILE.LANGUAGE.EN-US', value: Locale.US },
  ];
  translatedOptions: { value: string; label: string }[] = [];

  ngOnInit(): void {
    this.setupLanguageFormControl();
    this.translateLanguageOptions();
  }

  setLanguage(locale: string): void {
    this.localeService.setCurrentUserLocale(locale);
    this.translateLanguageOptions();
  }

  setupLanguageFormControl(): void {
    this.languageFormControl = new UntypedFormControl(
      this.localeService.getCurrentUserLocale(),
    );
  }

  translateLanguageOptions(): void {
    this.translatedOptions = this.options.map((option) => ({
      value: option.value,
      label: this.translateService.instant(option.label),
    }));
  }
}
